export default __webpack_public_path__ + "static/media/fireIcon.f26476c5.svg";